import { NativeAudio } from "@ionic-native/native-audio";
import { ServiceProvider } from "./../../providers/service/service";
import { TranslateService } from "@ngx-translate/core";
import { ShopperBuySocialPayScanConfirmPage } from "./../shopper-buy-social-pay-scan-confirm/shopper-buy-social-pay-scan-confirm";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";
import { QRScanner, QRScannerStatus } from "@ionic-native/qr-scanner";
import { Storage } from "@ionic/storage";

@IonicPage()
@Component({
  selector: "page-shopper-buy-social-pay-scan",
  templateUrl: "shopper-buy-social-pay-scan.html",
})
export class ShopperBuySocialPayScanPage {
  data = {
    merchant_id: "",
    shop_name: "",
    avalible: "",
    price: "",
    mission_id: "",
  };
  scanSub: any;
  plaza_id = "";
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private qrScanner: QRScanner,
    private loadingCtrl: LoadingController,
    public translateService: TranslateService,
    private services: ServiceProvider,
    private nativeAudio: NativeAudio,
    private storage: Storage
  ) {
    this.data = this.navParams.data;
    this.plaza_id = this.navParams.data.plaza_id;
    this.nativeAudio.preloadSimple("uniqueId1", "assets/sounds/qr.aac");
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    // console.log('ionViewDidLoad ShopperBuyProductPayScanPage');
    this.qrScanner
      .prepare()
      .then((status: QRScannerStatus) => {
        if (status.authorized) {
          // console.log('Camera Permission Given');
          this.scanSub = this.qrScanner.scan().subscribe((result: string) => {
            //  console.log('Scanned something', result);

            let loader = this.loadingCtrl.create({
              // content: "Loading Please Wait...",
              duration: 1000,
            });
            loader.present();

            // console.log("Scan data", this.data);
            var text = JSON.parse(result);
            // console.log('Scanned something', text);

            if (text.plaza_id == this.plaza_id) {
              this.nativeAudio.play("uniqueId1");
              this.navCtrl.push(ShopperBuySocialPayScanConfirmPage, {
                result: text.discount,
                data: this.data,
              });
            } else {
              this.translateService
                .get("Invalid discount.")
                .subscribe((value) => {
                  this.services.presentToast(value);
                });
            }

            this.qrScanner.hide();
            this.scanSub.unsubscribe();
          });

          this.qrScanner.show();
        } else if (status.denied) {
          console.log("Camera permission denied");
        } else {
          console.log("Permission denied for this runtime.");
        }
      })
      .catch((e: any) => console.log("Error is", e));
  }

  backPage() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-social-pay-scan/shopper-buy-social-pay-scan.ts